export default "__VITE_ASSET__JztuBTh$__"